// @flow

import { stopSubmit, stopAsyncValidation } from 'redux-form'
import { fork, put, take } from 'redux-saga/effects'
import config from 'src/config/formsConfig'
import { EDIT_ACCOUNT, editAccount } from 'src/redux/actions/accounts/accounts'
import http from 'src/services/http'
import { shapeRolesOnFormSubmit } from 'src/helpers/shapeRoles'
// types
import type { IOEffect } from 'redux-saga/effects'

function * watchEditAccount(): Generator<IOEffect, void, any> {
  while (true) {
    const {
      payload: { ...values },
    } = yield take(EDIT_ACCOUNT.REQUEST)
    const formId = config.orderAccountForm.id
    try {
      yield http('admin/user/edit', {
        body: JSON.stringify({
          ...shapeRolesOnFormSubmit(values),
        }),
        method: 'PUT',
      })

      yield put(editAccount.success(shapeRolesOnFormSubmit(values)))
    } catch (e) {
      yield put(editAccount.error(e.message))
      yield put(stopSubmit(formId, e.errors ? e.errors : {}))
      yield put(stopAsyncValidation(formId, e.errors ? e.errors : {}))
    }
  }
}

export default [fork(watchEditAccount)]
